{
  "es": {
    "baseChip": {
      "states": {
        "included": "incluido",
        "excluded": "excluido"
      }
    }
  }
}
